import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { OrderedInfosEdit } from "features/stock-ordering/core/stock-ordering.params";
import {
  stockOrderedEditInfoResponse,
  stockOrderedEditInfoRepository,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum StockOrderedEditInfoState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: StockOrderedEditInfoState;
  message: string;
}

const initialState: InitialState = {
  status: StockOrderedEditInfoState.initial,
  message: "",
};

export const stockOrderedEditInfo = createAsyncThunk(
  "stockOrderedEditInfo",
  async (param: OrderedInfosEdit, { rejectWithValue }) => {
    try {
      const response: stockOrderedEditInfoResponse =
        await stockOrderedEditInfoRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const stockOrderedEditInfoSlice = createSlice({
  name: "stockOrderedEditInfo",
  initialState,
  reducers: {
    resetstockOrderedEditInfoStatus: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(stockOrderedEditInfo.pending, (state) => {
        state.status = StockOrderedEditInfoState.inProgress;
      })
      .addCase(stockOrderedEditInfo.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = StockOrderedEditInfoState.success;
          state.message = message;
        }
      })
      .addCase(stockOrderedEditInfo.rejected, (state, action) => {
        state.status = StockOrderedEditInfoState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectStockOrderedEditInfo = (state: RootState) =>
  state.stockOrderedEditInfo;

export const { resetstockOrderedEditInfoStatus } =
  stockOrderedEditInfoSlice.actions;
export default stockOrderedEditInfoSlice.reducer;
